"use client";

import React from "react";

const BULB_COLORS = [
    { fill: "#ff2222", glow: "#ff4444", glowStrong: "#ff6666" },  // Red
    { fill: "#00dd00", glow: "#33ff33", glowStrong: "#66ff66" },  // Green
    { fill: "#2277ff", glow: "#44aaff", glowStrong: "#77ccff" },  // Blue
    { fill: "#ffdd00", glow: "#ffee44", glowStrong: "#ffff77" },  // Yellow
    { fill: "#ff7700", glow: "#ff9933", glowStrong: "#ffbb66" },  // Orange
];

export default function HolidayLights() {
    // Generate enough bulbs to fill wide screens
    const bulbCount = 60;

    return (
        <div
            className="holiday-lights t-w-full t-overflow-hidden t-relative t-z-50 print:t-hidden"
            style={{
                background: "linear-gradient(to bottom, #111111 0%, #1C1D1F 50%, #3a3a3a 75%, #ffffff 100%)"
            }}
            aria-hidden="true"
        >
            {/* Wire - with subtle highlight */}
            <div className="t-absolute t-top-[10px] t-left-0 t-right-0 t-h-[3px] t-bg-[#222] t-shadow-sm" />
            <div className="t-absolute t-top-[10px] t-left-0 t-right-0 t-h-[1px] t-bg-[#444]" />

            {/* Bulbs container */}
            <div className="t-flex t-justify-center t-items-start t-pt-2 t-pb-4">
                <div className="t-flex t-gap-[32px] t-px-4">
                    {Array.from({ length: bulbCount }).map((_, index) => {
                        const color = BULB_COLORS[index % BULB_COLORS.length];
                        const animationDelay = (index % 5) * 0.5;

                        return (
                            <div
                                key={index}
                                className="t-relative t-flex t-flex-col t-items-center"
                            >
                                {/* Socket/cap */}
                                <div className="t-w-[8px] t-h-[8px] t-bg-[#333] t-rounded-t-sm t-border-t t-border-x t-border-[#444]" />

                                {/* Bulb */}
                                <svg
                                    width="14"
                                    height="22"
                                    viewBox="0 0 14 22"
                                    className="bulb-glow"
                                    style={{
                                        animationDelay: `${animationDelay}s`,
                                        filter: `drop-shadow(0 0 6px ${color?.fill}) drop-shadow(0 0 10px ${color?.glow}) drop-shadow(0 0 12px ${color?.glow}) drop-shadow(0 0 20px ${color?.glowStrong})`,
                                    }}
                                >
                                    {/* C9 bulb shape - teardrop */}
                                    <path
                                        d="M7 0 C3.5 0 0 3.5 0 8 C0 14 3.5 22 7 22 C10.5 22 14 14 14 8 C14 3.5 10.5 0 7 0"
                                        fill={color?.fill}
                                    />
                                    {/* Inner glow gradient */}
                                    <path
                                        d="M7 2 C4.5 2 2 4.5 2 8 C2 12 4.5 18 7 18 C9.5 18 12 12 12 8 C12 4.5 9.5 2 7 2"
                                        fill={color?.glow}
                                        opacity="0.5"
                                    />
                                    {/* Highlight reflection */}
                                    <ellipse
                                        cx="4.5"
                                        cy="6"
                                        rx="2"
                                        ry="2.5"
                                        fill="rgba(255,255,255,0.4)"
                                    />
                                    <ellipse
                                        cx="4"
                                        cy="5"
                                        rx="1"
                                        ry="1.2"
                                        fill="rgba(255,255,255,0.6)"
                                    />
                                </svg>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
